/**
 * The sear hesitates. Not every time, which is worse than every time.
 */

import type { Affix } from '@/sim/items/affixContract';

export const STICKY_SEAR = {
  id: 'stickySear',
  slot: 'suffix',
  field: 'fireRate',
  direction: -1,
  label: 'Reduced fire rate',
  nameWord: 'of the Sticky Sear',
  ranges: {
    common: { min: 0.03, max: 0.06 },
    uncommon: { min: 0.05, max: 0.09 },
    rare: { min: 0.08, max: 0.13 },
    exotic: { min: 0.11, max: 0.17 },
  },
} as const satisfies Affix;
